import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

import { vegetablesIcons } from './vegetables';
import { fruitsIcons } from './fruits';
import { meatIcons } from './meat';
import { seafoodIcons } from './seafood';
import { dairyIcons } from './dairy';
import { grainsIcons } from './grains';
import { bakeryIcons } from './bakery';
import { condimentsIcons } from './condiments';
import { beveragesIcons } from './beverages';
import { othersIcons } from './others';

export const SvgIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  ...vegetablesIcons,
  ...fruitsIcons,
  ...meatIcons,
  ...seafoodIcons,
  ...dairyIcons,
  ...grainsIcons,
  ...bakeryIcons,
  ...condimentsIcons,
  ...beveragesIcons,
  ...othersIcons,
};
